module.exports = __webpack_public_path__ + "static/media/exit.1c4f5b78.svg";